export default (store) => store && store.state.user || null;